import { FORTEM_URIS } from '@/constants/uris'
import { AutomatedPricingPage } from '@/pages/operations/automated-pricing/page'
import { AutomatedNavPage } from '@/pages/operations/db-rec/automated-nav/page'
import { PositionsPnLPage } from '@/pages/operations/db-rec/positions-pnl/page'
import { OperationsLayout } from '@/pages/operations/layout'
import { MappingsPage } from '@/pages/operations/mappings/page'
import { MonthlyRollPage } from '@/pages/operations/monthly_roll/page'
import { NavUpdatePage } from '@/pages/operations/nav-update/page'
import { NtHedgingFwdPage } from '@/pages/operations/nt-hedging-fwd/page'
import { RiskCallibrationPage } from '@/pages/operations/risk-callibration/page'
import { TransactionReportingPage } from '@/pages/operations/tx-reporting/page'
import { PnLValidationPage } from '@/pages/pnl-attributions/page'
import type { CustomRouteObject, FortemRouteHandle } from '@/router'

export const operationsRoutes = [
  {
    path: FORTEM_URIS.OPERATIONS.__INDEX__,
    element: <OperationsLayout />,
    handle: {
      title: 'Operations',
    },
    children: [
      {
        path: FORTEM_URIS.OPERATIONS.BATCH_EXECUTOR,
        element: <RiskCallibrationPage />,
        handle: {
          title: 'Risk Calibration',
        },
      },
      {
        path: FORTEM_URIS.OPERATIONS.TX_REPORTING,
        element: <TransactionReportingPage />,
        handle: {
          title: 'TX Reporting',
        },
      },
      {
        path: FORTEM_URIS.OPERATIONS.NAV_UPDATE,
        element: <NavUpdatePage />,
        handle: {
          title: 'Nav Update',
        },
      },
      {
        path: FORTEM_URIS.OPERATIONS.AUTOMATED_PRICING,
        element: <AutomatedPricingPage />,
        handle: {
          title: 'Automated Pricing',
        },
      },
      {
        path: FORTEM_URIS.OPERATIONS.DB_REC.__INDEX__,
        handle: {
          title: 'DB REC',
        },
        children: [
          {
            path: FORTEM_URIS.OPERATIONS.DB_REC.AUTOMATED_NAV,
            element: <AutomatedNavPage />,
          },
          {
            path: FORTEM_URIS.OPERATIONS.DB_REC.POSITIONS_PNL,
            element: <PositionsPnLPage />,
          },
        ],
      },
      {
        path: FORTEM_URIS.OPERATIONS.MAPPINGS,
        element: <MappingsPage />,
        handle: {
          title: 'Mappings',
        },
      },
      {
        path: FORTEM_URIS.OPERATIONS.NT_HEDGING_FWD,
        element: <NtHedgingFwdPage />,
        handle: {
          title: 'NT Hedging Fwd',
        },
      },
      {
        path: FORTEM_URIS.OPERATIONS.MONTHLY_ROLL,
        element: <MonthlyRollPage />,
        handle: {
          title: 'Monthly Roll',
          docLink: 'https://www.notion.so/fortemcapital/Monthly-Roll-25bd1ec3585780f6a9f0f337192d0481',
        },
      },
      {
        path: FORTEM_URIS.OPERATIONS.PNL_VALIDATION,
        element: <PnLValidationPage />,
        handle: {
          title: 'P&L Attributions',
        },
      },
    ],
  },
] satisfies CustomRouteObject<FortemRouteHandle>[]
